import type {
  CrossborderCountryDto,
  UpdateYieldManagementSettingsDto,
} from '@carvia/ros-client-types';

export type CrossborderCountryCustomLabelFormEntry = {
  code: string;
  labels: {
    de?: string;
    en?: string;
    es?: string;
  };
};

export type CrossborderYmsFormFields = {
  crossborderCountryCodes: string[];
  crossborderCountryCustomLabels: CrossborderCountryCustomLabelFormEntry[];
};

export function hasCustomCrossborderLabels(
  labels?: CrossborderCountryCustomLabelFormEntry['labels'] | null,
): boolean {
  return !!(labels?.de?.trim() || labels?.en?.trim() || labels?.es?.trim());
}

export function splitCrossborderCountriesForForm(
  dto: Pick<UpdateYieldManagementSettingsDto, 'crossborderCountries'>,
): CrossborderYmsFormFields {
  return {
    crossborderCountryCodes: dto.crossborderCountries?.map((entry) => entry.code) ?? [],
    crossborderCountryCustomLabels:
      dto.crossborderCountries
        ?.filter((entry) => hasCustomCrossborderLabels(entry.labels))
        .map((entry) => ({
          code: entry.code,
          labels: entry.labels ?? {},
        })) ?? [],
  };
}

export function mergeCrossborderCountriesForApi(
  codes: string[],
  customLabels: CrossborderCountryCustomLabelFormEntry[],
): CrossborderCountryDto[] {
  return codes.map((code) => {
    const custom = customLabels.find((entry) => entry.code === code);
    if (!hasCustomCrossborderLabels(custom?.labels)) {
      return { code };
    }

    return {
      code,
      labels: {
        de: custom!.labels.de ?? '',
        en: custom!.labels.en ?? '',
        ...(custom!.labels.es?.trim() ? { es: custom!.labels.es } : {}),
      },
    };
  });
}
